<script>
import {getSuffix} from "@/common/js/tool";

export default {
  name: "file-viewer",
  props: {
    url: String
  },
  data() {
    return {

    }
  },
  computed: {
    type() {
      let res = "";
      const url = this.url;
      if (url) {
        const ext = getSuffix(url).replace(".", "");
        if (['doc','docx'].includes(ext)) {
          res = "word";
        } else if(["pdf"].includes(ext)) {
          res = "pdf";
        } else if(['pjp', 'jfif', 'pjpeg', 'avif', 'ico', 'tiff', 'gif', 'svg', 'bmp', 'png', 'xbm', 'jxl', 'jpeg', 'svgz', 'jpg', 'webp'].includes(ext)) {
          res = "image";
        } else {
          res = "unknown";
        }
      }
      return res;
    }
  }
}
</script>

<template>
<div class="file-viewer" v-if="url">
  <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`" width='100%' height='100%' frameborder='0' v-if="type === 'word'"></iframe>
  <object
      :data="url"
      type="application/pdf"
      width="100%"
      height="100%"
      v-else-if="type === 'pdf'"></object>
  <img :src="url" class="file-viewer-image" v-else-if="type === 'image'">
  <div class="file-viewer-tip" v-else>暂时不支持此格式的文件预览，请<a :href="url" target="_blank">下载文件</a> 查看</div>
</div>
</template>

<style lang="less">
.file-viewer {
  height: 100%;
  line-height: 1;
}
.file-viewer-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.file-viewer-tip {
  margin-top: 40px;
  text-align: center;
}
</style>